import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TextFieldComponent } from '../../../fields/standard/text-field/text-field.component';
import { AppModule } from '../../../../modules/app.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ThirdPartyModule } from '../../../../modules/third-party.module';
import { AngularModule } from '../../../../modules/angular.module';
import { SearchButtonComponent } from '../../../ui/forms/search-button/search-button.component';

@Component({
	selector: 'app-search-form',
	standalone: true,
	imports: [AppModule, ZorroModule, ThirdPartyModule, AngularModule, TextFieldComponent, SearchButtonComponent],
	templateUrl: './search-form.component.html',
	styleUrl: './search-form.component.scss',
})
export class SearchFormComponent {
	@Output('onSubmit') public onSubmitEmitter: EventEmitter<any> = new EventEmitter<any>();

	public form: FormGroup = this.fb.group({
		search: ['', []],
	});

	constructor(private fb: FormBuilder) {}

	public onSubmit() {
		this.onSubmitEmitter.emit(this.form.value);
	}
}
